export default __webpack_public_path__ + "static/media/Shraddha Varma.6877fb0b.jpg";